module.exports = __webpack_public_path__ + "static/media/banner-photo526@3x.078bdae5.webp";